// Prefixes for API calls
const API_BASE_PREFIX = process.env.REACT_APP_API_BASE_URL;
const AUTH_API_PREFIX = `${API_BASE_PREFIX}auth/`;
const PUBLIC_API_PREFIX = `${API_BASE_PREFIX}public/`;
const OPTIONS_API_PREFIX = `${API_BASE_PREFIX}options/`;
const AUTHENTICATED_API_PREFIX = `${API_BASE_PREFIX}authenticated/`;
const EVENT_API_PREFIX = `${AUTHENTICATED_API_PREFIX}event/`;
const TEMPLATE_API_PREFIX = `${AUTHENTICATED_API_PREFIX}template/`;
const GUESTS_API_PREFIX = `${AUTHENTICATED_API_PREFIX}guest/`;
const IMPORT_EXPORT_API_PREFIX = `${AUTHENTICATED_API_PREFIX}import-export/`;
const MESSAGE_TEMPLATE_API_PREFIX = `${AUTHENTICATED_API_PREFIX}message-template/`;
// const EMAIL_TEMPLATE_API_PREFIX = `${MESSAGE_TEMPLATE_API_PREFIX}email/`;
const CHECKIN_API_PREFIX = `${AUTHENTICATED_API_PREFIX}check-in/`;
const SEATING_CHART_API_PREFIX = `${AUTHENTICATED_API_PREFIX}seating-charts/`;
const REPORT_API_PREFIX = `${AUTHENTICATED_API_PREFIX}report/`;
const TAG_API_PREFIX = `${AUTHENTICATED_API_PREFIX}tags/`;
const SEAT_MANAGEMENT_API_PREFIX = `${AUTHENTICATED_API_PREFIX}seat/`;
const DIETARY_MANAGEMENT_API_PREFIX = `${AUTHENTICATED_API_PREFIX}dietary/`;
const IMPORT_LOG_API_PREFIX = `${AUTHENTICATED_API_PREFIX}import-log/`;
const USER_MANAGEMENT_API_PREFIX = `${AUTHENTICATED_API_PREFIX}user-management/`;
const CHANGE_LOG_API_PREFIX = `${AUTHENTICATED_API_PREFIX}change-log/`;
const LOW_END_API_PREFIX = `${AUTHENTICATED_API_PREFIX}low-end/`;
const ROLE_MANAGEMENT_API_PREFIX = `${AUTHENTICATED_API_PREFIX}role-management/`;

// Public Region API
export const GET_INVITATION_API = `${PUBLIC_API_PREFIX}invitation`;
export const LE_SEARCH_GUESTS_API = `${PUBLIC_API_PREFIX}search-guests`;
export const LE_CHECKIN_API = `${PUBLIC_API_PREFIX}check-in`;

// Auth Region API
export const LOGIN_API = `${AUTH_API_PREFIX}login`;
export const LOGOUT_API = `${AUTH_API_PREFIX}logout`;

// Authenticated Region API
// Event Region API
export const CURRENT_EVENT_LIST_API = `${EVENT_API_PREFIX}current`;
export const PAST_EVENT_LIST_API = `${EVENT_API_PREFIX}past`;
export const EVENT_CREATE_API = `${EVENT_API_PREFIX}create`;
export const GET_EVENT_INFO_API = `${EVENT_API_PREFIX}info`;
export const UPDATE_EVENT_INFO_API = `${EVENT_API_PREFIX}update`;
export const DELETE_EVENT_API = `${EVENT_API_PREFIX}delete`;
export const UPLOAD_TEMP_EVENT_IMAGE_API = `${EVENT_API_PREFIX}upload-temp-image`;
export const GET_EVENT_CUSTOMIZATION_API = `${EVENT_API_PREFIX}customization`;

// Template Region API
export const GET_TEMPLATE_LIST_API = `${TEMPLATE_API_PREFIX}`;

// Guest Region API
export const GUEST_LIST_API = `${GUESTS_API_PREFIX}list`;
export const GUEST_SUMMARY_API = `${GUESTS_API_PREFIX}summary`;
export const GUEST_CREATE_API = `${GUESTS_API_PREFIX}create`;
export const GUEST_INFO_API = `${GUESTS_API_PREFIX}info`;
export const GUEST_GROUP_API = `${GUESTS_API_PREFIX}group`;
export const GUEST_UPDATE_API = `${GUESTS_API_PREFIX}update`;
export const GUEST_BULK_UPDATE_API = `${GUESTS_API_PREFIX}bulk-update`;
export const GUEST_DELETE_API = `${GUESTS_API_PREFIX}delete`;
export const GUEST_REPORT_API = `${GUESTS_API_PREFIX}report`;
export const GUEST_CHECKIN_COUNT_API = `${GUESTS_API_PREFIX}guest-counter`;

// Import Export Region API
export const UPLOAD_TEMP_GUEST_LIST_API = `${IMPORT_EXPORT_API_PREFIX}upload`;
export const FETCH_TEMP_GUEST_LIST_API = `${IMPORT_EXPORT_API_PREFIX}fetch`;
export const CONFIRM_IMPORT_API = `${IMPORT_EXPORT_API_PREFIX}confirm-guest-list`;
export const EXPORT_GUEST_API = `${IMPORT_EXPORT_API_PREFIX}export-guest-list`;
export const EXPORT_GUEST_LIST_TEMPLATE = `${IMPORT_EXPORT_API_PREFIX}template`;
export const EXPORT_GUEST_REPORT_API = `${IMPORT_EXPORT_API_PREFIX}export-guest-report`;
export const EXPORT_DIETARY_REPORT_API = `${IMPORT_EXPORT_API_PREFIX}export-dietary-report`;
export const EXPORT_HOTEL_SUBMISSION_API = `${IMPORT_EXPORT_API_PREFIX}export-hotel-submission`;
export const UPLOAD_TEMP_LOW_END_GUEST_LIST_API = `${IMPORT_EXPORT_API_PREFIX}low-end-upload`;
export const EXPORT_IMPORT_TEMPLATE_API = `${IMPORT_EXPORT_API_PREFIX}export-import-template`;

// Message Template Region API
// Email
export const GET_EMAIL_TEMPLATE_LIST_API = `${MESSAGE_TEMPLATE_API_PREFIX}list`;
export const CREATE_EMAIL_TEMPLATE_API = `${MESSAGE_TEMPLATE_API_PREFIX}create`;
export const GET_EMAIL_TEMPLATE_DETAILS_API = `${MESSAGE_TEMPLATE_API_PREFIX}details`;
export const UPDATE_EMAIL_TEMPLATE_API = `${MESSAGE_TEMPLATE_API_PREFIX}update`;
export const GET_GUEST_COUNT_API = `${MESSAGE_TEMPLATE_API_PREFIX}guest-count`;
export const GET_REPLACED_MESSAGE_CONTENT_API = `${MESSAGE_TEMPLATE_API_PREFIX}get-replaced-message-content`;
export const SEND_MESSAGE_API = `${MESSAGE_TEMPLATE_API_PREFIX}send-message`;

// Tag Region API
export const GET_TAG_LIST_API = `${TAG_API_PREFIX}list`;
export const CREATE_TAG_API = `${TAG_API_PREFIX}create`;
export const UPDATE_TAG_API = `${TAG_API_PREFIX}update`;
export const GET_TAG_DETAILS_API = `${TAG_API_PREFIX}details`;
export const GET_GUESTS_TAG_API = `${TAG_API_PREFIX}guests`;
export const DELETE_TAG_API = `${TAG_API_PREFIX}delete`;
export const REMOVE_TAG_FROM_GUEST_API = `${TAG_API_PREFIX}remove-tag-from-guest`;

// Seat Management Region API
export const GET_CHECK_IN_WIDGET_API = `${SEAT_MANAGEMENT_API_PREFIX}check-in-widget`;
export const GET_SEATS_WIDGET_API = `${SEAT_MANAGEMENT_API_PREFIX}seats-widget`;
export const GET_AVAILABILITY_COUNT_API = `${SEAT_MANAGEMENT_API_PREFIX}availability-count`;
export const GET_TABLE_DETAIL_LIST_API = `${SEAT_MANAGEMENT_API_PREFIX}table`;
export const CREATE_TABLE_API = `${SEAT_MANAGEMENT_API_PREFIX}create-table`;
export const GET_TABLE_GUESTS_API = `${SEAT_MANAGEMENT_API_PREFIX}table-guests`;
export const GET_TABLE_DETAILS_API = `${SEAT_MANAGEMENT_API_PREFIX}table-details`;
export const UPDATE_TABLE_API = `${SEAT_MANAGEMENT_API_PREFIX}update`;
export const DELETE_TABLE_API = `${SEAT_MANAGEMENT_API_PREFIX}delete`;
export const ASSIGN_GUEST_API = `${SEAT_MANAGEMENT_API_PREFIX}assign-guest`;
export const UNSEAT_GUEST_API = `${SEAT_MANAGEMENT_API_PREFIX}unseat-guest`;

// Check In Region API
export const GET_EVENT_DETAILS_API = `${CHECKIN_API_PREFIX}event`;
export const GET_GUESTS_API = `${CHECKIN_API_PREFIX}guests`;
export const GET_GUEST_OPTIONS_API = `${CHECKIN_API_PREFIX}guest-options`;
export const GET_GUEST_INFO_API = `${CHECKIN_API_PREFIX}guest-info`;
export const GET_GROUP_MEMBERS_API = `${CHECKIN_API_PREFIX}group-members`;
export const GET_OPEN_TABLES_API = `${CHECKIN_API_PREFIX}open-tables`;
export const UPDATE_GUEST_NOTE_API = `${CHECKIN_API_PREFIX}update-note`;
export const CHECK_IN_API = `${CHECKIN_API_PREFIX}check-in`;
export const CHECK_OUT_API = `${CHECKIN_API_PREFIX}check-out`;
export const WALK_IN_API = `${CHECKIN_API_PREFIX}walk-in`;

// Report Region API
export const GET_REPORT_WIDGET_API = `${REPORT_API_PREFIX}widget`;
export const GET_GUEST_REPORT_API = `${REPORT_API_PREFIX}guests`;

// Seating Chart Region API
export const GET_SEATING_HEADER_API = `${SEATING_CHART_API_PREFIX}header-data`;
export const GET_TABLES_GUESTS_API = `${SEATING_CHART_API_PREFIX}tables`;
export const GET_UNSEATED_GUESTS_API = `${SEATING_CHART_API_PREFIX}unseated-guests`;
export const MOVE_GUEST_API = `${SEATING_CHART_API_PREFIX}move-guest`;
export const UPDATE_GUESTS_SEATS_API = `${SEATING_CHART_API_PREFIX}update`;
export const FETCH_GUEST_DETAILS_API = `${SEATING_CHART_API_PREFIX}guest-details`;
export const GET_FLOORPLAN_API = `${SEATING_CHART_API_PREFIX}floorplan`;

// Import Log Region API
export const GET_IMPORT_LOG_LIST_API = `${IMPORT_LOG_API_PREFIX}list`;
export const GET_IMPORT_LOG_DETAILS_API = `${IMPORT_LOG_API_PREFIX}details`;

// Change Log Region API
export const GET_CHANGE_LOG_LIST_API = `${CHANGE_LOG_API_PREFIX}list`;

// Dietary Management Region API
export const GET_DIETARY_WIDGET_API = `${DIETARY_MANAGEMENT_API_PREFIX}widget`;
export const GET_DIETARY_LIST_API = `${DIETARY_MANAGEMENT_API_PREFIX}list`;
export const CREATE_DIETARY_API = `${DIETARY_MANAGEMENT_API_PREFIX}create`;
export const GET_DIETARY_DETAILS_API = `${DIETARY_MANAGEMENT_API_PREFIX}details`;
export const UPDATE_DIETARY_API = `${DIETARY_MANAGEMENT_API_PREFIX}update`;
export const GET_DIETARY_GUESTS_API = `${DIETARY_MANAGEMENT_API_PREFIX}guests`;
export const REMOVE_GUEST_DIETARY_API = `${DIETARY_MANAGEMENT_API_PREFIX}remove`;
export const DELETE_DIETARY_API = `${DIETARY_MANAGEMENT_API_PREFIX}delete`;

// User Management Region API
export const GET_USER_DETAILS_API = `${USER_MANAGEMENT_API_PREFIX}details`;
export const GET_USER_LIST_API = `${USER_MANAGEMENT_API_PREFIX}list`;
export const CREATE_USER_API = `${USER_MANAGEMENT_API_PREFIX}create`;
export const UPDATE_USER_API = `${USER_MANAGEMENT_API_PREFIX}update`;
export const DELETE_USER_API = `${USER_MANAGEMENT_API_PREFIX}delete`;

// Role Management Region API
export const GET_ROLE_LIST_API = `${ROLE_MANAGEMENT_API_PREFIX}list`;
export const GET_ROLE_DETAILS_API = `${ROLE_MANAGEMENT_API_PREFIX}details`;
export const CREATE_ROLE_API = `${ROLE_MANAGEMENT_API_PREFIX}create`;
export const UPDATE_ROLE_API = `${ROLE_MANAGEMENT_API_PREFIX}update`;
export const DELETE_ROLE_API = `${ROLE_MANAGEMENT_API_PREFIX}delete`;
export const GET_PERMISSION_LIST_API = `${ROLE_MANAGEMENT_API_PREFIX}permissions`;

// Options Region API
export const DIETARY_OPTIONS_API = `${OPTIONS_API_PREFIX}dietary`;
export const AVAILABLE_TABLE_OPTIONS_API = `${OPTIONS_API_PREFIX}available-table`;
export const ALL_TABLE_OPTIONS_API = `${OPTIONS_API_PREFIX}all-table`;
export const NO_TABLE_GUEST_OPTIONS_API = `${OPTIONS_API_PREFIX}no-table-guest`;
export const MESSAGE_GUEST_OPTIONS_API = `${OPTIONS_API_PREFIX}message-guest-list`;
export const GET_FONTS_API = `${OPTIONS_API_PREFIX}font`;
export const TAG_OPTIONS_API = `${OPTIONS_API_PREFIX}tag`;
export const EVENT_OPTIONS_API = `${OPTIONS_API_PREFIX}event`;
export const ROLE_OPTIONS_API = `${OPTIONS_API_PREFIX}role`;

// Low end mode API
export const LE_EVENT_LIST_API = `${LOW_END_API_PREFIX}events`;
export const LE_CREATE_EVENT_API = `${LOW_END_API_PREFIX}create-event`;
export const LE_EVENT_INFO_API = `${LOW_END_API_PREFIX}event-info`;
export const LE_UPDATE_EVENT_API = `${LOW_END_API_PREFIX}update-event`;
export const LE_GUEST_LIST_API = `${LOW_END_API_PREFIX}guests`;
export const LE_GUEST_ADD_API = `${LOW_END_API_PREFIX}add-guest`;
export const LE_GUEST_EDIT_API = `${LOW_END_API_PREFIX}edit-guest`;
export const LE_GUEST_DELETE_API = `${LOW_END_API_PREFIX}delete-guest`;
export const LE_GUEST_IMPORT_API = `${LOW_END_API_PREFIX}import-guest-list`;
